module.exports = __webpack_public_path__ + "img/allottee2_7-8-2021.6ce27b48.jpg";